"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.largeTag = exports.smallTag = exports.variantTag = exports.baseTag = void 0;

var _stylitas = require("@creditas/stylitas");

const baseTag = ({
  theme
}) => (0, _stylitas.css)`
  background-color: ${theme.bColorneutral01};
  border: 1px solid ${theme.bColorneutral06};
  height: 32px;
  border-radius: 16px;
  display: inline-flex;
  align-items: center;
  padding: 8px;

  p {
    color: ${theme.bColorneutral07};
    margin: 0 7px 0 8px;
  }

  span {
    width: 16px;
    height: 16px;
    border-radius: 8px;
    background-color: ${theme.bColorneutral06};
  }
`;

exports.baseTag = baseTag;

const variantTag = ({
  color
}) => color && (0, _stylitas.css)`
    border-color: ${color};

    span {
      background-color: ${color};
    }
  `;

exports.variantTag = variantTag;

const smallTag = ({
  size
}) => size === 'small' && (0, _stylitas.css)`
    padding: 4px;
    height: 16px;

    span {
      width: 8px;
      height: 8px;
    }

    p {
      margin-right: 4px;
      margin: 0 4px 0 5px;
      font-size: 14px;
    }
  `;

exports.smallTag = smallTag;

const largeTag = ({
  size
}) => size === 'large' && (0, _stylitas.css)`
    padding: 12px;
    height: 48px;
    border-radius: 24px;

    span {
      width: 24px;
      height: 24px;
      border-radius: 12px;
    }

    p {
      margin-right: 4px;
      margin: 0 10px 0 11px;
      font-size: 20px;
    }
  `;

exports.largeTag = largeTag;